import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import { appendHeaderFormatter } from '@elliemae/ds-shared/useDataGrid/initColumnDefinition';
import { useResizeHandle } from './useResizeHandle.js';

var addResizableToColumn = function addResizableToColumn(column, formatter) {
  return appendHeaderFormatter(formatter, column);
};

var ResizableWrapper = /*#__PURE__*/React.memo(function (_ref) {
  var value = _ref.value,
      onDrag = _ref.onDrag,
      onDragEnd = _ref.onDragEnd,
      onDragStart = _ref.onDragStart,
      minWidth = _ref.minWidth,
      handleClassName = _ref.handleClassName;

  var _useResizeHandle = useResizeHandle({
    onDrag: onDrag,
    onDragEnd: onDragEnd,
    onDragStart: onDragStart,
    minWidth: minWidth,
    handleClassName: handleClassName
  }),
      containerRef = _useResizeHandle.containerRef,
      Handle = _useResizeHandle.Handle;

  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: "resize-container"
  }, value, /*#__PURE__*/React.createElement(Handle, null));
}); // eslint-disable-next-line react/display-name

var resizableFormatter = function resizableFormatter(options) {
  return function (value) {
    return /*#__PURE__*/React.createElement(ResizableWrapper, _extends({}, options, {
      value: value
    }));
  };
};

export { addResizableToColumn, resizableFormatter };
//# sourceMappingURL=decorateResizable.js.map
